import { destroy,mutate,query, update } from "../../defaults/fetch";
import {useState,useEffect} from "react";


export const useGetAllUnits = (flag)=>{
    const [units,setUnits] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const getAllUnits = async()=>{
            setLoading(true);
            const url = `unit/get-all`;
            const {data} = await query(url);
            setLoading(false);
            setUnits(data);
        }
        getAllUnits();
    },[flag])

    return {loading,units};
}


export const useCreateUnit = ()=>{
    const createUnit = async(body)=>{
        const url = `unit/create`;
        const {message} = await mutate(url,true,body);
        return message;
    }
    return createUnit;
}

export const useUpdateUnit = ()=>{
    const updateUnit = async(id,body)=>{
        const url = `unit/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateUnit;
}



export const useDeleteUnit = ()=>{
    const deleteUnit = async(id)=>{
        const url = `unit/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteUnit;
}